package app.nestbridge.app.usecase

import com.karawek.core.auth.api.AuthSessionStore
import com.karawek.core.auth.model.AuthSession
import kotlinx.coroutines.flow.Flow
import me.tatarka.inject.annotations.Inject

/**
 * Streams the persisted auth session. Emits the current value on subscribe, then
 * on every change (login writes a session, logout / expiry clears it to `null`).
 * Used by the app-level auth gate to route to login the moment the session is lost.
 */
@Inject
class ObserveAuthSessionUseCase(
    private val authSessionStore: AuthSessionStore,
) {
    operator fun invoke(): Flow<AuthSession?> = authSessionStore.observe()
}
